import React from "react";
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom'



const Bangalore = () => {
  return (
    <div>
        <Helmet>
        <title>About Us – Best VLSI Training Institute in India | Takshila VLSI</title>
        <meta name="description" content="Learn about job-oriented VLSI courses, expert trainers, practical training, and placement support in Bangalore and Hyderabad with Takshila VLSI." />
        <link rel="canonical" href="https://www.takshila-vlsi.com/about-us/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="About Us – Best VLSI Training Institute in India | Takshila VLSI" />
        <meta property="og:description" content="Learn about Takshila VLSI, our mission, values, and expert training programs. Discover how we shape careers in VLSI. Visit our site to learn more today!" />
        <meta property="og:url" content="https://www.takshila-vlsi.com/about-us/" />
        <meta property="og:site_name" content="Takshila VLSI" />
        <meta property="article:modified_time" content="2022-03-01T13:54:06+00:00" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>

        <Header/>

        <main>

        </main>

        <Footer/>

    </div>
  )
}

export default Bangalore